module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonecvm-00.2.0a29ea62.jpg";